import { Button, Card, Col, Form, Radio, Row, Select, Image, Input, Drawer } from 'antd'
import QuestionService from '../../../services/QuestionService';
import { openNotification } from '../../../utils';
import { useEffect, useState } from 'react';
import { IQuestionRequest } from '../../../types/Question';
import VimeoPlayer from '../../../components/Subjects/Components/VimeoPlayer';
import VideoList from '../../../components/Video/VideoList';

const { Item } = Form;

interface QuestionViewProps {
  questionId: number;
  getTrigger: any;
  setCurrentQuestionId: any;
}

const QUESTION_TYPE_OPTIONS = [
  { value: 'LESSON', label: 'Ders' },
  { value: 'QUIZ', label: 'Sınav' }
];

const QuestionUpdate: React.FC<QuestionViewProps> = ({ questionId, getTrigger, setCurrentQuestionId }) => {
  const [subjectId, setSubjectId] = useState<number | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false)
  const [vimeoId, setVimeoId] = useState(null);
  const [answerType, setAnwserType] = useState<boolean>(false)
  const [showDrawer, setShowDrawer] = useState(false);

  const [form] = Form.useForm();
  const [pdfUrl, setPdfUrl] = useState<string>('');

  useEffect(() => {
    if (questionId) {
      getQuestion();
    }
  }, [questionId]);

  const getQuestion = () => {
    setLoading(true)
    QuestionService.get(questionId)
      .then((response: any) => {
        const data = response.data
        setSubjectId(data?.subjectId)
        form.setFieldsValue({
          correctAnswer: data?.correctAnswer,
          answerType: data?.answerType,
          videoUrl: data?.videoUrl,
          file: data?.file,
          questionType: data?.questionType || 'LESSON'  // EKLENDİ
        });

        setVimeoId(data?.vimeoId);
        setAnwserType(data?.answerType);
        getFile(data?.question);
        setLoading(false)
        getTrigger();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  const getFile = (fileName: any) => {
    QuestionService.getFile(fileName).then((response: any) => {
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(pdfBlob);
      setPdfUrl(url);
    }).catch((e: Error) => {

    });

  }

  const update = (values: any) => {
    let postObj: any = {
      "correctAnswer": values.correctAnswer,
      "answerType": values.answerType,
      "vimeoId": values.vimeoId,
      "subjectId": subjectId !== undefined ? subjectId : 0,
      "questionType": values.questionType 
    };

    QuestionService.update(questionId, postObj)
      .then((response: any) => {
        openNotification('success', 'Başarılı', 'Soru Başarıyla Düzenlendi')
        setCurrentQuestionId(null)
        getTrigger()
        setShowDrawer(false);
      }).catch((e: Error) => {
        openNotification('error', 'Başarısız', 'Soru Düzenlenemedi.')
        console.log(e)
      });
  }

  return (
    <>
      <Button className='mr-12' onClick={() => setShowDrawer(true)}>
        Düzenle
      </Button>
      <Drawer title="Soru Düzenle" placement="right" onClose={() => setShowDrawer(false)} open={showDrawer}>
        <Row justify={'center'}>
          <Col xl={24} xs={24}>
            <Form form={form} onFinish={update} layout="vertical">
              {pdfUrl && <Image src={pdfUrl} width="100%" />}
              <Item
                name="questionType"
                label="Soru Türü"
                rules={[
                  {
                    required: true,
                    message: 'Soru türü zorunlu',
                  }]}
              >
                <Select options={QUESTION_TYPE_OPTIONS} />
              </Item>
              <Item
                name="answerType"
                label="Soru Tipi"
                rules={[
                  {
                    required: true,
                    message: 'Soru Tipi zorunlu',
                  }]}
              >
                <Radio.Group defaultValue={answerType}>
                  <Radio value={2}>Doğru/Yanlış</Radio>
                  <Radio value={4}>4 Cevaplı</Radio>
                  <Radio value={5}>5 Cevaplı</Radio>
                </Radio.Group>
              </Item>
              <Item
                name="correctAnswer"
                label="Doğru Cevap"
                rules={[
                  {
                    required: true,
                    message: 'Doğru cevap zorunlu',
                  }]}
              >
                <Select options={
                  [
                    { value: "A", label: "Doğru - A" },
                    { value: "B", label: "Yanlış - B" },
                    { value: "C", label: "C" },
                    { value: "D", label: "D" },
                    { value: "E", label: "E" },
                  ]
                } />
              </Item>
              {(vimeoId) ? <><VimeoPlayer videoId={vimeoId}></VimeoPlayer><Button danger onClick={() => { setVimeoId(null) }}>Sil</Button></> : <VideoList setVimeoId={(id: any) => { setVimeoId(id) }}></VideoList>}
              <Item>
                <Row justify={'end'}>
                  <Button className='btn btn-hover-dark bg-saha-purple font-color-white fw-700 btn-text' htmlType="submit">
                    Kaydet
                  </Button>
                </Row>
              </Item>
            </Form>
          </Col>
        </Row>
      </Drawer>
    </>
  )
}

export default QuestionUpdate
